
function handleTouchMove(e)
{
  e.preventDefault();
}
function freezeBody()
{
  console.log('freezing');
  $('body').addClass('frozen-body').on('touchmove', handleTouchMove);
}
function unfreezeBody()
{
 console.log('unfreezing');
  $('body').removeClass('frozen-body').off('touchmove');
}

(() => {
    let oldPushState = history.pushState;
    history.pushState = function pushState() {
        let ret = oldPushState.apply(this, arguments);
        window.dispatchEvent(new Event('pushstate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    };

    let oldReplaceState = history.replaceState;
    history.replaceState = function replaceState() {
        let ret = oldReplaceState.apply(this, arguments);
        window.dispatchEvent(new Event('replacestate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    };

    window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('locationchange'));
    });
})();

function freeShippingBarUpdate(){
  let smartCart = window.Rebuy.SmartCart;
  if(smartCart && smartCart.progressBar){
    let label = $('#rebuy-cart__progress-bar-meter-label');
    let meter = $(label).closest('.rebuy-cart__progress-bar-wrapper').find('.rebuy-cart__progress-bar-meter');

    $(meter).prepend(label);
    
    const freeShippingTier = smartCart.progressBar.tiers.find(tier => tier.type === 'shipping').minimum*100;
    const subtotal = Math.min(smartCart.shippingExcludedSubtotal(), window.Rebuy.Cart.subtotal());
    let priceDifference = freeShippingTier - subtotal;
  
    if(subtotal > 0){
      $('.cart-link__bubble').addClass('cart-link__bubble--visible');
    } else {
      $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
    }
    let text, width;
  
    if(priceDifference > 0) {
      text = `You're $${(priceDifference/100).toFixed(2)} away from free shipping!`;
      width = `${(subtotal/freeShippingTier)*100}%`;
    } else {
      text = `Free shipping unlocked! 🎉`;
      width = `100%`;
    }
    $('.custom-free-shipping-bar').each(function(i,obj){
      $(obj).find('div').css('width',width)
    });
    $('.custom-free-shipping-text').each(function(i,obj){
      $(obj).html(text);
    });
  } else {
    console.log('No progress bar found')
  }
}
var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

$(document).ready(function() {
  console.log('Ready');
  // if (['caffeinated-energy-bars','caffeinated-protein-bars','variety-packs'].some(v => window.location.pathname.includes(v))) {
  //   console.log('Matches URL path');
  //   function clickProductPDP(){
  //     let productEl = $('#'+window.location.pathname.substr(window.location.pathname.indexOf('/products/')+10));
  //     if(productEl){
  //       let startingColor = $(productEl).css('background-color');
  //       setTimeout(function(){
  //         $(productEl).click();
  //         if($(productEl).css('background-color') == startingColor || !$(productEl).css('background-color')){
  //           clickProductPDP(); 
  //         }
  //       },1000);
  //     }
  //   }
  //   clickProductPDP();
  // }
  // if(window.location.pathname.indexOf('/products/caffeinated-energy-bars'))
  //   function clickProduct() {
  //       console.log('in this script');
  //       console.log(window.location.pathname);
  //       console.log(document.getElementById(window.location.pathname.substr(window.location.pathname.indexOf('/products/')+10)))
  //       document.getElementById(window.location.pathname.substr(window.location.pathname.indexOf('/products/')+10)).click();
  //   }
    
    
  $('.cart-link').on('click',function(e){
    e.preventDefault();
  })
  $('.pcp-badge').each(function(i, obj){
    let span = $(this).parent().parent().find('span');
    let opacity = $(span).parent().css('opacity');
    let text = $(span).text().trim();
    if(opacity === "0") {
      if(text){
        $(this).html(text);
        $(this).css({
          'padding':'5px 10px 5px 10px',
          'background-color':'#E5FF77',
          'font-weight':'bold',
          'border':'solid 3px #243C2E',
          'border-left':'none',
          'border-top-right-radius':'3px',
          'border-bottom-right-radius':'3px'
        })
      }
    } else {
      if(text === "") {
        $(span).parent().css('opacity',"0%");
      }
    }
  });

  

  let notScrolling = true;
  
  function customScroll(element, offset=0) {
    if(~element.indexOf("#/shop")) {
      if(~element.indexOf("#/shop/subscriptions")) {
        portalLoaded = false;
        loadPortal();
      }
      return;
    }
    
    console.log('Setting not scrolling to false')
    notScrolling = false;
    if(~element.indexOf("#first-product")){
      offset = 200;
    }
    $('html, body').animate({
        scrollTop: $(element).offset().top - offset
    }, 500);
    setTimeout(function(){
          console.log('Setting not scrolling back to true')
        notScrolling = true;
    }, 1000);
  }
  
  $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      customScroll($.attr(this, 'href'));
  });

  $('.utm-passthrough').on('click',function(e){
      e.preventDefault();
      let urlEl = $(this).find('[href]')
      let url = $(urlEl).data('url') || $(urlEl).attr('href');
      let querystring = window.location.search.substring(1);
      querystring += (querystring ? `&` : ``) + `pathname=${window.location.pathname}`;
      let newUrl = url.indexOf('?') != -1 ?url+'&'+querystring : url+'?'+querystring;
      window.location.href = newUrl;
      wait(3000);
      alert('pausing');
  });

  document.addEventListener('cart:updated', function(evt) {
    if(evt && evt.detail && evt.detail.cart && evt.detail.cart.subtotal){
      $('.free-shipping-section').each(function(i, obj){
        let threshold = parseInt($(this).data('threshold'));
        let subtotal = parseInt(evt.detail.cart.subtotal);
        let percent = Math.min(1, subtotal / threshold);
        let text = subtotal < threshold ? `$${((threshold - subtotal)/100).toFixed(2)} away from free shipping` : `You've unlocked free shipping! 🎉` 

        $(this).find('.free-shipping-background').css('width',`${percent*100}%`);
        $(this).find('.free-shipping-text').text(text);
      });
    }
  });

  document.addEventListener('variant:change', function(evt) {
    console.log(evt);
  })

  var setSearchParam = function(key, value) {
    if (!window.history.pushState) {
        return;
    }

    if (!key) {
        return;
    }

    var url = new URL(window.location.href);
    var params = new window.URLSearchParams(window.location.search);
    if (value === undefined || value === null) {
        params.delete(key);
    } else {
        params.set(key, value);
    }

    url.search = params;
    url = url.toString();
    window.history.replaceState({url: url}, null, url);
}
  $('select').on('change', function() {
    if($(this).closest('#offer-section').length > 0) {
      setSearchParam('variant', this.value ); 
    }
  });
  
  document.addEventListener('rebuy:cart.change', (event) => {
    freeShippingBarUpdate();
  });
  
  document.addEventListener('rebuy:smartcart.ready', (event) => {
    freeShippingBarUpdate();

    setTimeout(function(){
      freeShippingBarUpdate();
    },500)
    setTimeout(function(){
      freeShippingBarUpdate();
    },1000)
    setTimeout(function(){
      freeShippingBarUpdate();
    },1500)
    setTimeout(function(){
      freeShippingBarUpdate();
    },2000)
  });

  function updateActiveElement(hashmark) {
    let navElement = $(`a[href='${hashmark}']`).closest('[role="button"]');
    let navBar = $(navElement).parent().parent().parent();
    if(!$(navElement).hasClass('active-pcp-nav')){
      $(navBar).find('[role="button"').removeClass('active-pcp-nav');
  
      if($(navElement)[0]){
        var pos=$(navElement).position().left; //get left position of li
        
        $(navBar).animate({
          scrollLeft: pos-60
        });
        $(navElement).addClass('active-pcp-nav');
      }
    }
    
  }
  document.addEventListener('pcp-nav:clicked', (event) => {
    if(event.detail){
      customScroll(event.detail);
      updateActiveElement(event.detail);
    }
  });

  function findClosest(selector){
    let currentClosest = 100000000;
    let closest;
    $(selector).each(function(i,obj){
      let distance = $(obj).offset().top - $(window).scrollTop() - 132;
      if(Math.abs(distance) < currentClosest && distance < 0){
        closest = obj; 
        currentClosest = Math.abs(distance);
      }
    })
    return closest;
  }

  // Only run this on the PCP
  if($('#pcp-nav')[0]) {
    let navBar = $("#pcp-nav").parent().parent();
    $(navBar).find('[role="button"').addClass('pcp-nav');
    updateActiveElement('#featured');
    
    $(window).scroll(function(){
      setTimeout(function(){
        if(notScrolling){
          let closest = findClosest('[data-alchemy-url-hashmark]:not([data-alchemy-url-hashmark="first-product"])');
          updateActiveElement('#'+$(closest).attr('id'));
        }
      }, 500);
    });
  }
  
});













